import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Blog, BlogPost } from "../components/hub/Blog";

export default function BlogPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  return (
    <div className="min-h-screen grain" style={{ background: "var(--app-bg)" }} data-testid="blog-page">
      <header className="max-w-5xl mx-auto px-5 pt-6 flex items-center gap-2">
        <Link to="/" className="flex items-center gap-2"><div className="w-8 h-8 flex items-center justify-center bg-gold text-black font-head font-bold text-sm">F</div><span className="font-head font-bold text-white">Fateh FX</span></Link>
        <span className="text-xs text-slate-500 ml-1">Blog</span>
        <Link to="/results" className="ml-auto text-xs text-slate-400 hover:text-white">Live Results</Link>
      </header>
      <main className="max-w-5xl mx-auto px-5 py-8">
        {slug ? <BlogPost slug={slug} onBack={() => nav("/blog")} /> : <Blog />}
      </main>
    </div>
  );
}
